import * as React from 'react';

function _define_property(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _object_spread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _define_property(target, key, source[key]);
    });
  }

  return target;
}

var IconShoppingBag_6 = function IconShoppingBag_6(props) {
  return /*#__PURE__*/React.createElement("svg", _object_spread({
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.70473 12.2622C8.11215 12.1875 8.50299 12.4572 8.57768 12.8646L9.16446 16.0653H27.1553C27.3776 16.0653 27.5886 16.1639 27.7311 16.3347C27.8736 16.5054 27.9329 16.7306 27.8932 16.9494L25.9855 27.4417C25.9206 27.7983 25.61 28.0575 25.2476 28.0575H10.463C10.101 28.0575 9.79062 27.7989 9.72533 27.4427L7.10227 13.1351C7.02758 12.7277 7.29731 12.3369 7.70473 12.2622ZM9.43946 17.5653L11.088 26.5575H24.6216L26.2566 17.5653H9.43946Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9482 32.3154C15.9482 33.2374 15.2008 33.9849 14.2788 33.9849C13.3568 33.9849 12.6094 33.2374 12.6094 32.3154C12.6094 31.3934 13.3568 30.646 14.2788 30.646C15.2008 30.646 15.9482 31.3934 15.9482 32.3154Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5791 32.3154C23.5791 33.2374 22.8317 33.9849 21.9097 33.9849C20.9877 33.9849 20.2402 33.2374 20.2402 32.3154C20.2402 31.3934 20.9877 30.646 21.9097 30.646C22.8317 30.646 23.5791 31.3934 23.5791 32.3154Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3477 13C13.3477 12.5858 13.6834 12.25 14.0977 12.25H17.8512C18.2654 12.25 18.6012 12.5858 18.6012 13V16.7536C18.6012 17.1678 18.2654 17.5036 17.8512 17.5036H14.0977C13.6834 17.5036 13.3477 17.1678 13.3477 16.7536V13ZM14.8477 13.75V16.0036H17.1012V13.75H14.8477Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1016 13C17.1016 12.5858 17.4373 12.25 17.8516 12.25H21.6051C22.0193 12.25 22.3551 12.5858 22.3551 13V16.7536C22.3551 17.1678 22.0193 17.5036 21.6051 17.5036H17.8516C17.4373 17.5036 17.1016 17.1678 17.1016 16.7536V13ZM18.6016 13.75V16.0036H20.8551V13.75H18.6016Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5 14.75C36.5 19.0302 33.0302 22.5 28.75 22.5C24.4698 22.5 21 19.0302 21 14.75C21 10.4698 24.4698 7 28.75 7C33.0302 7 36.5 10.4698 36.5 14.75Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.119 18.4846C30.8129 18.4846 31.8591 17.4981 31.8591 16.0334C31.8591 14.5985 30.8527 13.7217 29.5076 13.7217C28.6506 13.7217 28.1126 14.0804 27.7837 14.6085C27.8236 13.1437 28.3716 12.3665 29.2585 12.3665C29.8762 12.3665 30.1154 12.6555 30.215 13.1238H31.7097C31.5502 11.8185 30.6535 11.1509 29.2385 11.1509C27.4948 11.1509 26.1895 12.4961 26.1895 14.9074V15.0868C26.1895 17.0298 26.9667 18.4846 29.119 18.4846ZM29.099 17.3188C28.3816 17.3188 27.8834 16.8206 27.8834 16.0035C27.8834 15.296 28.3816 14.7878 29.099 14.7878C29.8264 14.7878 30.2748 15.306 30.2748 16.0533C30.2748 16.8006 29.8065 17.3188 29.099 17.3188Z",
    fill: "white"
  }));
};

export { IconShoppingBag_6 };